exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".manager-toolbar {\n\t margin-bottom: 23px;\n}\n\n.manager-toolbar .btn {\n\ttransition: background-color 0s !important;\n}\n", ""]);

// exports
